<template>
  <select v-model="selectedArticle" :id="htmlId" class="form-control">
    <option v-for="article in articles"
            class="form-control"
            :key="article.id"
            :value="article"
            :selected="selectedArticle && article.id === selectedArticle.id">
      <slot :article="article">
        {{ article.product.name }}
      </slot>
    </option>
  </select>
</template>

<script>
import {arrayQueryString} from "@/utils/axios-utils";
import {DateTime} from "luxon";

export default {
  props: {
    htmlId: String,
    categories: {
      type: Array,
      default: () => []
    },
    validOnDate: {
      type: Object,
      default: () => DateTime.now()
    }
  },
  data() {
    return {
      articles: [],
      selectedArticle: undefined
    }
  },
  methods: {
    loadArticles() {
      return this.$api.get('/articles', {
        params: {
          channel: 'WEB',
          categories: arrayQueryString(this.categories)
          // valid: this.validOnDate.toFormat("yyyy-MM-yy")
        }
      }).then(response => {
        this.articles = response.data
      }).catch(error => this.handleError(error))
    }
  },
  watch: {
    articles() {
      if (this.articles && this.articles.length > 0 && !this.selectedArticle)
        this.selectedArticle = this.articles[0]
      else if (this.selectedArticle && this.articles && this.articles.map(a => a.id).indexOf(this.selectedArticle.id) < 0) {
        this.showWarning(this.selectedArticle.product.name + ' ist in diesem Zeitraum nicht verfügbar. Wähle ein anderes Erlebnis.')
        this.selectedArticle = undefined
      }
    },
    selectedArticle() {
      this.$emit('input', this.selectedArticle)
    },
    validOnDate() {
      this.loadArticles()
    }
  },
  activated() {
    console.info('activated')
    const articleId = this.$route.query.article
    if (articleId > 0) {
      this.$api.get(`/articles/${articleId}`)
          .then(r => this.selectedArticle = r.data)
          .catch(error => this.handleError(error))
    }
  },
  mounted() {
    this.loadArticles()
  }
}
</script>

